import React from 'react';
import { tConvert } from '../../../../utils/config/constants';

const ReceivedMessageCell = ({ conversation, user }) => {
    return (
        <div className="d-flex flex-nowrap chat-item align-items-center">
            <img
                width="50px"
                height="50px"
                className="rounded-circle avatar"
                src={conversation.user.avatar}
                alt="image"
            />

            <div className="bubble">
                <div className="message">{conversation.text}</div>
                <div className="time text-muted text-right mt-2">
                    {conversation.user.name} -{' '}
                    {tConvert(new Date(conversation.created_at))}
                </div>
            </div>
        </div>
    );
};

export default ReceivedMessageCell;



// WEBPACK FOOTER //
// ./src/components/chatPanel/Conversation/ReceivedMessageCell/index.js